<div class="flex items-center justify-center w-screen h-screen bg-auto bg-primary bg-no-repeat bg-cente">
  <div class="max-w-md w-full outline outline-zinc-800 rounded-xl bg-white">
    <form action="#" class="flex flex-col gap-5 p-10" [formGroup]="form">
      <div class="flex justify-center items-center mb-1">
        <img src="assets/logo.png" alt="Logo" class="h-14 w-auto" />
        <span class="font-bold text-lg text-[#D6AF59]">CKK ERP</span>
      </div>
      <div class="text-center mb-2.5">
        <h3 class="text-lg font-medium leading-none mb-2.5 text-back">Sign In</h3>
      </div>
      <!-- Alert Message -->
      @if (errorMessage()) {
        <div class="bg-red-50 border border-red-200 text-red-500 rounded-xl px-4 py-2 flex items-center gap-2 mb-3 animate-fade-in-up">
          <svg class="h-5 w-5 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{{ errorMessage() }}</span>
        </div>
      }
      <div class="flex flex-col gap-1">
        <rise-ng-input
          id="username"
          label="Username"
          formControlName="username"
          placeholder="Enter Username"
          [error]="errors.username"
          [isDisabled]="isLoading()"
        ></rise-ng-input>
      </div>
      <div class="flex flex-col gap-1">
        <rise-ng-input
          id="password"
          label="Password"
          formControlName="password"
          placeholder="Enter Password"
          [inputType]="'password'"
          [error]="errors.password"
          [isDisabled]="isLoading()"
        ></rise-ng-input>
      </div>

      <button
        type="submit"
        class="w-full cursor-pointer bg-primary text-white py-2 rounded-lg font-semibold shadow transition flex items-center justify-center gap-2"
        [disabled]="isLoading()"
        (click)="login()"
      >
        @if (!isLoading()) {
          <span class="text-lg"></span> Sign In
        } @else {
          <svg class="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="3" opacity="0.18" />
            <path d="M12 3a9 9 0 0 1 9 9" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
          </svg>
          <span>loading...</span>
        }
      </button>
    </form>
  </div>
</div>
